import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../../services/firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';

const Login = () => {
  const [email, setEmail]         = useState("");
  const [password, setPassword]   = useState("");
  const [validation, setValidation] = useState(null);
  const [loading, setLoading]     = useState(false);
  const navigate = useNavigate();

  const Auth = async () => {
    if (!email.trim() || !password.trim()) {
      setValidation("E-posta ve şifre gereklidir.");
      return;
    }

    setLoading(true);
    setValidation(null);
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/admin/new-article');
    } catch {
      setValidation("Geçersiz e-posta veya şifre.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="container"
      style={{ alignItems: 'center', paddingTop: 60, maxWidth: 500, margin: '0 auto' }}
    >
      <h2>Admin Girişi</h2>

      <form
        className="form"
        style={{ alignItems: 'center', position: 'relative' }}
        onSubmit={(e) => { e.preventDefault(); Auth(); }}
      >
        <div>
          {validation && (
            <span style={{ color: 'red', display: 'block', marginBottom: 12 }}>
              {validation}
            </span>
          )}

          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', marginBottom: 4 }}>E-posta</label>
            <input
              className="glass-input"
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              value={email}
              placeholder="ornek@email.com"
              required
            />
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', marginBottom: 4 }}>Şifre</label>
            <input
              className="glass-input"
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              value={password}
              placeholder="********"
              required
            />
          </div>
          <button
            type="submit"
            className="glass-button"
            disabled={loading}
            style={{ marginTop: 30, width: 250, height: 50, opacity: loading ? 0.6 : 1 }}
          >
            {loading ? 'Giriş yapılıyor...' : 'Giriş Yap'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default Login;
